import React from 'react';
import { Card } from '../ui/Card';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
type DiveTypesChartProps = {
  data: {
    name: string;
    value: number;
    color: string;
  }[];
};
export const DiveTypesChart: React.FC<DiveTypesChartProps> = ({
  data
}) => {
  return <Card className="h-64" data-id="element-260">
      <h3 className="font-semibold mb-4" data-id="element-261">Dive Types</h3>
      <div className="h-52" data-id="element-262">
        <ResponsiveContainer width="100%" height="100%" data-id="element-263">
          <PieChart data-id="element-264">
            <Pie data={data} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-265">
              {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-266" />)}
            </Pie>
            <Tooltip formatter={(value, name) => [`${value} dives`, name]} data-id="element-267" />
            <Legend layout="vertical" verticalAlign="middle" align="right" data-id="element-268" />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Card>;
};